import React from "react";
import CreditUsageTable from "@/components/CreditUsageTable/CreditUsageTable";
import { useDashboardTheme } from "../MeetingDashboard/themeHelper";

const CreditUsagePage: React.FC = () => {
    const { isDark } = useDashboardTheme();
    return (
        <main className={"flex-1 p-4 md:p-6 mt-15 " + (isDark ? "" : "light-theme-dashboard")} style={{ background: isDark ? "" : "#F4F5F7" }}>
            <CreditUsageTable />
        </main>
    );
};

export default CreditUsagePage;
